import { render, staticRenderFns } from "./SetPassRuleContent.vue?vue&type=template&id=6f11f995&scoped=true"
import script from "./SetPassRuleContent.vue?vue&type=script&lang=js"
export * from "./SetPassRuleContent.vue?vue&type=script&lang=js"
import style0 from "./SetPassRuleContent.vue?vue&type=style&index=0&id=6f11f995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f11f995",
  null
  
)

export default component.exports